// @flow

import { graphql } from 'react-relay';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation ReceiveReturnOrderMutation($input: ReceiveReturnOrderInput!) {
    receiveReturnOrder(input: $input) {
      returnOrderEdge {
        node {
          id
          returnNumber
          status
          returnType
          reason
          authorizedDate
          receivedDate
          notes
          customerNotes
          order {
            id
            orderNumber
          }
          customer {
            id
            name
          }
          lines(first: 1000) {
            edges {
              node {
                id
                quantity
                receivedQuantity
                condition
                disposition
                restocked
                notes
                item {
                  id
                  name
                  itemNumber
                }
              }
            }
          }
          updatedAt
          createdAt
        }
      }
    }
  }
`;

export default {
  commit: (options: Object) => {
    return createRelayMutation(mutation, options);
  },
};
